import React from 'react';
import styled from 'styled-components/macro';

const sizeMap = {
  base: '2rem',
  lg: '3rem',
  sm: '1rem',
};
export const SpinnerStyled = styled.div<{ size: 'sm' | 'base' | 'lg' }>`
  color: ${(props) => props.theme.colors.primary.main};
  width: ${(props) => sizeMap[props.size]};
  height: ${(props) => sizeMap[props.size]};
`;

type Props = {
  size?: 'sm' | 'base' | 'lg';
};

export const LoadingIndicator: React.FC<Props> = ({ size = 'base' }: Props) => {
  return (
    <SpinnerStyled className="spinner-border" size={size} role="status">
      <span className="sr-only" />
    </SpinnerStyled>
  );
};
